import {http} from '../utils'
// 查询
const searchAction = (params) => {
  const url = `/config/notice/page`
  return http.post(url, params)
}
// 获取用户列表
const getAuditUsers = () => {
  const url = '/api/v1/users/all'
  return http.post(url)
}
// 获取数据源列表
const optionsAction = (params) => {
  const url = `/config/dataSourceConfigInfo/list`
  return http.post(url, params)
}
// 获取 详情
const getAction = (id) => {
  const url = `/config/notice/detail/${id}`
  return http.post(url)
}
//获取 inbound 列表
const getNameDropdown = (params) => {
  const url = `/config/apiConfigInfo/getListByDirection`
  return http.post(url, params)
}
// 新建
const addAction = (params) => {
  const url = `/config/notice/save`
  return http.post(url, params)
}
// 修改禁用启用
const statusAction = (params) => {
  const url = `/config/notice/changeStatus`
  return http.post(url, params)
}
// cron
const scheduleAction = (params) => {
  const url = `/config/notice/changeCron`
  return http.post(url, params)
}
// 删除
const deleteAction = (id) => {
  const url = `/config/notice/delete/${id}`
  return http.post(url)
}

// 测试连接
const textDB = (params) => {
  const url = `/config/notice/test`
  return http.post(url, params)
};
export default {
  searchAction,
  getAuditUsers,
  optionsAction,
  getNameDropdown,
  getAction,
  addAction,
  statusAction,
  scheduleAction,
  deleteAction,
  textDB
}
